import type { TBookingContext } from '@providers/booking/types'
import { isCheckInOutTimeEnabled } from 'components-ui/src/shared'
import type { LocationBookingConfClientDto } from 'service-api/src/types/api'

export const getBookingFlowLocationBookingConf = (state: TBookingContext): LocationBookingConfClientDto | undefined =>
  state.data.reservation?.locationBookingConf ?? state.config.serviceType

export const shouldShowArrivalDeparturesBookingStep = (state: TBookingContext): boolean => {
  const lbc = getBookingFlowLocationBookingConf(state)
  return lbc ? isCheckInOutTimeEnabled(lbc) : false
}
